import { useNavigate, useSearchParams } from "react-router";

import { SystemStatusPage } from "@nens/ranalib";

import dropsWiseBackgroundSrc from "@/images/dropswise-background.svg?url";
import dropsWiseLogoSrc from "@/images/dropswise-logo.svg?url";

export function LoginPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const chooseTenantCode = (tenantCode: string) => navigate(`/${tenantCode}`);

  if (searchParams.has("demo")) {
    return (
      <SystemStatusPage
        variant="dropswise-welcome"
        logoSrc={dropsWiseLogoSrc}
        backgroundSrc={dropsWiseBackgroundSrc}
        chooseTenantCode={chooseTenantCode}
      />
    );
  }

  return <SystemStatusPage variant="welcome" chooseTenantCode={chooseTenantCode} />;
}
